<template>
  <div class="flex flex-col gap-y-8">
    <!-- 新動線の S2。体験・日時は出さず（D-043）、見出しはアコーディオン側、総額は下部固定バーが出す（D-014） -->
    <ReservationOptionFields :experience-event="props.experienceEvent" :get-error-message="props.getErrorMessage" hides-single-interpreter-choice />
  </div>
</template>

<script setup lang="ts">
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';
import ReservationOptionFields from '@/wabunka-src/features/Experience/subFeatures/Reservation/pages/Reserve/components/ReservationSection/ReservationStep2Form/ReservationOptionFields/ReservationOptionFields.vue';

interface Props {
  getErrorMessage: (s: string) => string;
  experienceEvent: WabunkaExperienceEventViewModel;
}
const props = defineProps<Props>();
</script>
